import React, { useEffect } from "react";
import BookdocLogo from "assets/logos/Sidebar.svg";
import QrStepOne from "assets/icons/qr-step-1.svg";
import QrStepTwo from "assets/icons/qr-step-2.svg";
import QrStepThree from "assets/icons/qr-step-3.svg";
import AuthService from "services/auth.service";
import { QRCodeCanvas } from "qrcode.react";

export function QRCodeTemplate() {
  const practiceLocation = AuthService.getPracticeLocation();
  const userObject = JSON.parse(localStorage.getItem("user"));
  const deeplinkBaseUrl = process.env.REACT_APP_DEEPLINK_BASE_URL;
  const path = "employee-benefits/doctor/";
  const url = `${deeplinkBaseUrl}${path}${practiceLocation.id}`;

  const qrcode = (
    <QRCodeCanvas
      id="qrCode"
      value={url}
      size={400}
      bgColor={"#F2F2F2"}
      level={"H"}
    />
  );

  useEffect(() => {
    setTimeout(window.print, 1000);
  }, []);

  return (
    <div id="qr-template">
      <div className="header">
        <img alt="logo" src={BookdocLogo} />
      </div>
      <div id="qr-template-container">
        <div className="qr-template-title">
          SCAN QR CODE FOR PRE-REGISTRATION
        </div>
        <div>{qrcode}</div>
        <div className="body">
          <div className="body-text">
            {userObject?.title + " " + userObject?.name}
          </div>
          <div className="body-text">{practiceLocation?.name}</div>
        </div>

        <div className="footer">
          <div className="footer-title">How it works</div>
          <div className="footer-content">
            <img className="flex-row-img" alt="logo" src={QrStepOne} />
            <img className="flex-row-img" alt="logo" src={QrStepTwo} />
            <img className="flex-row-img" alt="logo" src={QrStepThree} />
            <div className="flex-row-item-1">STEP 1</div>
            <div className="flex-row-item-1">STEP 2</div>
            <div className="flex-row-item-1">STEP 3</div>
            <div className="flex-row-item-2">Scan QR Code</div>
            <div className="flex-row-item-2">Choose Entitlement</div>
            <div className="flex-row-item-2">Confirm Registration</div>
          </div>
        </div>
      </div>
    </div>
  );
}
